/**
 * mechatReport.ts — in-app reporting of an abusive account.
 *
 * Google Play requires apps with 1:1 messaging to offer in-app reporting and
 * blocking, and to act on reports. Messages live in the blockchain and cannot be
 * deleted, so "acting" means hiding client-side: the reporter's own block list
 * takes effect immediately, and the report reaches us so the account can go on
 * the shipped block list in a later release.
 *
 * There is no backend yet, so the report is handed to the user's mail app. The
 * moment a report endpoint exists, replace `openReport` with a POST — the call
 * sites do not change.
 */

export const REPORT_EMAIL = 'support@properwallet.app'

export interface ReportPayload {
  reporter: string
  reported: string
  /** Transaction ids of the offending messages, if known. */
  messageIds?: string[]
  note?: string
}

export function buildReportBody(payload: ReportPayload): string {
  const lines = [
    'ProperWallet — abuse report (mechat)',
    '',
    `Reported account: ${payload.reported}`,
    `Reported by:      ${payload.reporter}`,
    `Time:             ${new Date().toISOString()}`,
  ]
  if (payload.messageIds?.length) {
    lines.push(`Transactions:     ${payload.messageIds.slice(0, 10).join(', ')}`)
  }
  if (payload.note) lines.push('', 'Note:', payload.note)
  lines.push(
    '',
    'Message text is end-to-end encrypted and is not included automatically —',
    'add it below if you want us to see it.',
    '',
  )
  return lines.join('\n')
}

export function openReport(payload: ReportPayload): void {
  const subject = `Abuse report: ${payload.reported}`
  const url =
    `mailto:${REPORT_EMAIL}` +
    `?subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(buildReportBody(payload))}`
  try {
    window.open(url, '_blank')
  } catch {
    window.location.href = url
  }
}
